module.exports = __webpack_public_path__ + "img/rs-back.2f8d0f99.svg";